import { primaryColor } from "../../constants";
// import { SpinnerContainer } from "./spinner.styles";
import ClipLoader from "react-spinners/ClipLoader";

const Spinner = ({ size, color, borderWidth = "8px" }) => {
    const fg = color ? color : primaryColor;
    // Use 10% opacity background based on the foreground color if hex, else fallback rgba
    const bg = /^#([A-Fa-f0-9]{6})$/.test(fg) ? `${fg}1A` : "rgba(52, 64, 84, 0.10)";
    return (
        // <SpinnerContainer />
        <ClipLoader
            color={fg}
            loading={true}
            cssOverride={{
                display: "block",
                margin: "0 auto",
                borderWidth,
                borderStyle: "solid",
                borderColor: `${bg} ${bg} ${fg}`,
            }}
            speedMultiplier={0.8}
            size={size ? size : 70}
            aria-label="Loading Spinner"
            data-testid="loader"
        />
    );
};

export default Spinner;